/**
 * Arkusz raportu dziennego handlowca (`dailySheet.*`) — „Mój raport dzienny” i podgląd w raportach zespołu.
 * Scalane przez `extra.ts`; `dailySheetEn` jest typowany względem `dailySheetPl`. Etykiety enumów: shared `cardEnum.*`.
 */
export const dailySheetPl = {
  nav: 'Mój raport dzienny',
  title: 'Mój raport dzienny',
  subtitle: 'Raport aktywności handlowej (owoce i warzywa): wizyty i kontakty dnia, uwagi, podsumowania tygodni T1–T5 i miesiąca.',
  tabs: { day: 'Dzień', week: 'Tydzień', month: 'Miesiąc' },
  date: { label: 'Data raportu', prev: 'Poprzedni dzień', next: 'Następny dzień', today: 'Dziś' },
  region: { label: 'Rejon', placeholder: 'np. Kraków – Nowa Huta', none: 'Rejon nie podany' },
  col: {
    no: 'Lp.',
    client: 'Klient',
    clientStatus: 'Status klienta',
    b2b: 'B2B',
    email: 'E-mail osoby kontaktowej',
    place: 'Gdzie',
    contactPerson: 'Z kim rozmowa',
    supplier: 'Obecny dostawca',
    deliveries: 'Dostawy / tydz.',
    potential: 'Potencjał O+W / mc',
    offer: 'Oferta',
    novelties: 'Nowości',
    outcome: 'Efekt rozmowy',
    nextContact: 'Kolejny kontakt',
    phone: 'Nr telefonu',
    actions: 'Akcje',
  },
  yes: 'Tak',
  no: 'Nie',
  rows: {
    title: 'Wizyty i kontakty',
    add: 'Dodaj wiersz',
    fromVisits: 'Dodaj z wizyt',
    edit: 'Edytuj wiersz',
    remove: 'Usuń wiersz',
    empty: 'Brak wierszy — dodaj wizytę lub kontakt albo pobierz je z zakończonych wizyt.',
    emptyReadonly: 'Brak wpisanych wizyt i kontaktów w tym dniu.',
    fromVisit: 'z wizyty',
    potentialClient: 'spoza bazy',
    limit: 'Osiągnięto limit {max} wierszy na dzień.',
  },
  editor: {
    titleNew: 'Nowy wiersz raportu',
    titleEdit: 'Wiersz raportu',
    sectionClient: 'Klient',
    sectionTalk: 'Rozmowa',
    sectionBusiness: 'Współpraca',
    customer: 'Klient z bazy',
    customerPlaceholder: 'Szukaj klienta w swojej bazie…',
    clientName: 'albo nazwa potencjalnego klienta (spoza bazy)',
    clientNamePlaceholder: 'np. Bistro Pod Lipą',
    clientRequired: 'Wybierz klienta z bazy albo wpisz nazwę potencjalnego klienta.',
    emailInvalid: 'Nieprawidłowy adres e-mail.',
    supplierOther: 'Nazwa innego dostawcy',
    none: '—',
    apply: 'Zastosuj',
    cancel: 'Anuluj',
  },
  comment: {
    label: 'Uwagi / wnioski z dnia',
    placeholder: 'Najważniejsze obserwacje, sygnały z rynku, sprawy do załatwienia…',
    empty: 'Brak uwag z dnia.',
    counter: '{count}/{max}',
  },
  summary: {
    day: 'Podsumowanie dnia',
    live: 'liczone na bieżąco',
    visits: 'Wizyty / kontakty',
    novelties: 'Nowości',
    potential: 'Potencjał O+W / mc',
    b2b: 'B2B',
    offers: 'Oferty',
    followUps: 'Umówione kolejne kontakty',
    clientStatuses: 'Statusy klientów',
    distinctSuppliers: 'Różni dostawcy konkurencji',
  },
  potential: { range: '{min} – {max}', open: 'od {min}' },
  save: {
    button: 'Zapisz',
    saved: 'Raport zapisany.',
    dirty: 'Niezapisane zmiany',
    clean: 'Zapisano',
    discardConfirm: 'Masz niezapisane zmiany w raporcie. Porzucić je?',
  },
  submit: {
    button: 'Wyślij raport',
    resend: 'Wyślij ponownie',
    confirmTitle: 'Wysłać raport?',
    confirmBody: 'Raport z dnia {date} trafi do Twojego kierownika i zarządu. Po wysłaniu możesz go poprawiać tylko do końca tego dnia.',
    confirmResend: 'Raport był już wysłany — kierownik i zarząd dostaną powiadomienie, że został zaktualizowany.',
    confirmUnsaved: 'Niezapisane zmiany zostaną najpierw zapisane.',
    confirm: 'Wyślij',
    cancel: 'Anuluj',
    done: 'Raport wysłany.',
    sentAt: 'Wysłany {time}',
    draft: 'Szkic — niewysłany',
    changedAfter: 'Zmieniono po wysłaniu — wyślij ponownie',
    readOnly: 'Tylko podgląd — raport wysłany w poprzednim dniu nie może być już zmieniany.',
  },
  suggestions: {
    title: 'Dodaj z zakończonych wizyt',
    description: 'Wizyty zakończone {date}, których jeszcze nie ma w raporcie.',
    empty: 'Brak zakończonych wizyt do dodania.',
    loadError: 'Nie udało się wczytać wizyt.',
    selectAll: 'Zaznacz wszystkie',
    add: 'Dodaj zaznaczone ({count})',
    cancel: 'Anuluj',
    added: 'Dodano wiersze: {count}. Pamiętaj, żeby zapisać raport.',
  },
  export: { label: 'Pobierz Excel', day: 'Raport dnia (Excel)', month: 'Cały miesiąc (Excel)' },
  week: {
    title: 'Tydzień {label}',
    pick: 'Tydzień miesiąca',
    days: 'Dni tygodnia',
    day: 'Dzień',
    submitted: 'Wysłany',
    notSubmitted: 'Niewysłany',
    total: 'Razem',
  },
  month: {
    title: 'Miesiąc',
    prev: 'Poprzedni miesiąc',
    next: 'Następny miesiąc',
    weeks: 'Tygodnie T1–T5',
    week: 'Tydzień',
    total: 'Razem miesiąc',
    avg: 'Średnio na tydzień',
  },
  note: {
    weekTitle: 'Wnioski tygodnia',
    monthTitle: 'Wnioski miesiąca',
    placeholder: 'Podsumuj okres: co działa, gdzie są szanse, czego potrzebujesz…',
    empty: 'Brak notatki do tego okresu.',
    save: 'Zapisz notatkę',
    saved: 'Notatka zapisana.',
    updated: 'Zmieniono {time}',
  },
  ranking: {
    title: 'Ranking dostawców konkurencji',
    team: 'cały zespół',
    supplier: 'Dostawca',
    count: 'Wskazania',
    clients: 'Klienci',
    emails: 'E-maile',
    empty: 'Brak wskazań dostawców konkurencji w tym okresie.',
    other: 'inny',
  },
  hero: {
    visits: 'Wizyty / kontakty',
    novelties: 'Nowości',
    potential: 'Potencjał',
    status: 'Status',
  },
  errors: {
    REPORT_LOCKED: 'Raport jest zablokowany — został wysłany, a dzień już minął.',
    REPORT_EMPTY: 'Nie można wysłać pustego raportu — dodaj wiersz albo uwagi dnia.',
    VALIDATION: 'Popraw dane raportu: {message}',
    FORBIDDEN: 'Brak uprawnień do tego raportu.',
    NOT_FOUND: 'Nie znaleziono raportu lub handlowca.',
    generic: 'Nie udało się zapisać raportu.',
    load: 'Nie udało się wczytać raportu.',
  },
  team: {
    pickRep: 'Kliknij handlowca na liście, aby zobaczyć jego arkusz raportu, podsumowania i dostawców.',
    sheetOf: 'Raport: {name}',
    close: 'Zamknij podgląd',
    select: 'Pokaż raport',
  },
};

export const dailySheetEn: typeof dailySheetPl = {
  nav: 'My daily report',
  title: 'My daily report',
  subtitle: 'Sales activity report (fruit & vegetables): the day’s visits and contacts, notes, W1–W5 weekly and monthly summaries.',
  tabs: { day: 'Day', week: 'Week', month: 'Month' },
  date: { label: 'Report date', prev: 'Previous day', next: 'Next day', today: 'Today' },
  region: { label: 'Region', placeholder: 'e.g. Kraków – Nowa Huta', none: 'No region given' },
  col: {
    no: 'No.',
    client: 'Customer',
    clientStatus: 'Customer status',
    b2b: 'B2B',
    email: 'Contact e-mail',
    place: 'Where',
    contactPerson: 'Talked to',
    supplier: 'Current supplier',
    deliveries: 'Deliveries / week',
    potential: 'F&V potential / month',
    offer: 'Offer',
    novelties: 'New products',
    outcome: 'Outcome',
    nextContact: 'Next contact',
    phone: 'Phone',
    actions: 'Actions',
  },
  yes: 'Yes',
  no: 'No',
  rows: {
    title: 'Visits and contacts',
    add: 'Add row',
    fromVisits: 'Add from visits',
    edit: 'Edit row',
    remove: 'Remove row',
    empty: 'No rows yet — add a visit or contact, or pull them from completed visits.',
    emptyReadonly: 'No visits or contacts entered for this day.',
    fromVisit: 'from visit',
    potentialClient: 'not in database',
    limit: 'The limit of {max} rows per day has been reached.',
  },
  editor: {
    titleNew: 'New report row',
    titleEdit: 'Report row',
    sectionClient: 'Customer',
    sectionTalk: 'Conversation',
    sectionBusiness: 'Business',
    customer: 'Customer from database',
    customerPlaceholder: 'Search your customers…',
    clientName: 'or a prospect’s name (not in database)',
    clientNamePlaceholder: 'e.g. Linden Bistro',
    clientRequired: 'Pick a customer from the database or type a prospect’s name.',
    emailInvalid: 'Invalid e-mail address.',
    supplierOther: 'Other supplier name',
    none: '—',
    apply: 'Apply',
    cancel: 'Cancel',
  },
  comment: {
    label: 'Notes / takeaways of the day',
    placeholder: 'Key observations, market signals, things to follow up…',
    empty: 'No notes for the day.',
    counter: '{count}/{max}',
  },
  summary: {
    day: 'Day summary',
    live: 'updated live',
    visits: 'Visits / contacts',
    novelties: 'New products',
    potential: 'F&V potential / month',
    b2b: 'B2B',
    offers: 'Offers',
    followUps: 'Follow-ups scheduled',
    clientStatuses: 'Customer statuses',
    distinctSuppliers: 'Distinct competitor suppliers',
  },
  potential: { range: '{min} – {max}', open: 'from {min}' },
  save: {
    button: 'Save',
    saved: 'Report saved.',
    dirty: 'Unsaved changes',
    clean: 'Saved',
    discardConfirm: 'You have unsaved changes in the report. Discard them?',
  },
  submit: {
    button: 'Send report',
    resend: 'Send again',
    confirmTitle: 'Send the report?',
    confirmBody: 'The report for {date} goes to your manager and the board. Once sent, you can only correct it until the end of that day.',
    confirmResend: 'The report was already sent — your manager and the board will be notified that it was updated.',
    confirmUnsaved: 'Unsaved changes will be saved first.',
    confirm: 'Send',
    cancel: 'Cancel',
    done: 'Report sent.',
    sentAt: 'Sent {time}',
    draft: 'Draft — not sent',
    changedAfter: 'Changed after sending — send again',
    readOnly: 'Read only — a report sent on an earlier day can no longer be changed.',
  },
  suggestions: {
    title: 'Add from completed visits',
    description: 'Visits completed on {date} that are not in the report yet.',
    empty: 'No completed visits to add.',
    loadError: 'Could not load visits.',
    selectAll: 'Select all',
    add: 'Add selected ({count})',
    cancel: 'Cancel',
    added: 'Rows added: {count}. Remember to save the report.',
  },
  export: { label: 'Download Excel', day: 'Day report (Excel)', month: 'Whole month (Excel)' },
  week: {
    title: 'Week {label}',
    pick: 'Week of month',
    days: 'Days of the week',
    day: 'Day',
    submitted: 'Sent',
    notSubmitted: 'Not sent',
    total: 'Total',
  },
  month: {
    title: 'Month',
    prev: 'Previous month',
    next: 'Next month',
    weeks: 'Weeks W1–W5',
    week: 'Week',
    total: 'Month total',
    avg: 'Average per week',
  },
  note: {
    weekTitle: 'Week takeaways',
    monthTitle: 'Month takeaways',
    placeholder: 'Sum up the period: what works, where the opportunities are, what you need…',
    empty: 'No note for this period.',
    save: 'Save note',
    saved: 'Note saved.',
    updated: 'Changed {time}',
  },
  ranking: {
    title: 'Competitor supplier ranking',
    team: 'whole team',
    supplier: 'Supplier',
    count: 'Mentions',
    clients: 'Customers',
    emails: 'E-mails',
    empty: 'No competitor suppliers mentioned in this period.',
    other: 'other',
  },
  hero: {
    visits: 'Visits / contacts',
    novelties: 'New products',
    potential: 'Potential',
    status: 'Status',
  },
  errors: {
    REPORT_LOCKED: 'The report is locked — it was sent and the day is over.',
    REPORT_EMPTY: 'An empty report cannot be sent — add a row or notes of the day.',
    VALIDATION: 'Fix the report data: {message}',
    FORBIDDEN: 'You have no access to this report.',
    NOT_FOUND: 'Report or sales rep not found.',
    generic: 'Could not save the report.',
    load: 'Could not load the report.',
  },
  team: {
    pickRep: 'Click a sales rep in the list to see their report sheet, summaries and suppliers.',
    sheetOf: 'Report: {name}',
    close: 'Close preview',
    select: 'Show report',
  },
};
